import { CreateStakingIntent } from "@/features/treasury/treasury";

export default function TreasuryStakingNewPage() {
  return <CreateStakingIntent />;
}
